import { render } from "./CreateServiceForm.vue?vue&type=template&id=20287032"
import script from "./CreateServiceForm.vue?vue&type=script&lang=js"
export * from "./CreateServiceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__